import callApi from "helpers/callApi";

export const getCompanyReadiness = async () => {
  const response = await callApi("/documents/company_readiness", "GET");
  const data = await response.json().catch(() => ({}));

  return { response, data };
};
